import { render, staticRenderFns } from "./OrderBoxIcon.vue?vue&type=template&id=1da65af8&"
import script from "./OrderBoxIcon.vue?vue&type=script&lang=js&"
export * from "./OrderBoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports